import { generateRepositoryMethods } from '../webapp/repository.types.js';
import { appRepositoryMethods } from './app.methods.js';
import { patientRepositoryMethods } from './patient.methods.js';
import { prescriptionRepositoryMethods } from './prescription.methods.js';
import { promotionRepositoryMethods } from './promotion.methods.js';
import { userRepositoryMethods } from './user.methods.js';
export const adminBffMethods = generateRepositoryMethods(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, appRepositoryMethods), patientRepositoryMethods), prescriptionRepositoryMethods), promotionRepositoryMethods), userRepositoryMethods));
//# sourceMappingURL=repository.types.js.map